import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { fmtErr } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { toast } from "sonner";

export default function Reset() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const token = sp.get("token") || "";

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/auth/reset-password", { token, password }); toast.success("Password reset! Please sign in."); nav("/login"); }
    catch (err) { toast.error(fmtErr(err.response?.data?.detail)); setBusy(false); }
  };

  return (
    <AuthShell title="Set a new password" subtitle="Choose a strong password.">
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <input type="password" required minLength={6} placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" className="w-full px-4 py-3 rounded-xl border border-stone-200 outline-none focus:border-[var(--friib)]" />
        <button disabled={busy || !token} data-testid="reset-submit" className="w-full py-3.5 rounded-full font-bold text-white disabled:opacity-60" style={{ background: "var(--friib)" }}>{busy ? "Resetting…" : "Reset password"}</button>
        {!token && <p className="text-sm text-red-500">Missing or invalid reset token.</p>}
      </form>
      <p className="mt-6 text-center text-sm text-stone-500"><Link to="/login" className="font-bold text-[var(--friib)]">Back to sign in</Link></p>
    </AuthShell>
  );
}
